import React, { Fragment } from "react";
import { displayPerformance, getPerformanceAndPrevious } from "./utilities";
import { ImplementationTrackingSection } from "@hpo/client/models/Archive";
import smoothJoin from "@hpo/client/utilities/smoothJoin";
import Programs from "@hpo/client/utilities/Programs";
import { IndicatorTypeLabels } from "@hpo/client/utilities/enums/IndicatorType";

type ImplementationTrackingProps = {
  payload: ImplementationTrackingSection;
};

export function ImplementationTracking(props: ImplementationTrackingProps) {
  const { payload } = props;
  const { title, periods, programs } = payload;
  return (
    <Fragment>
      <h2>{title}</h2>
      {`Indicateurs d'évalution pour ${periods.length === 1 ? periods[0] : smoothJoin(periods)}, pour chaque projet (par appel à projet et bénéficiaire)`}
      {programs.map((program) => {
        return (
          <Fragment key={program.key}>
            <h3>{Programs[program.key].label}</h3>
            {program.organizations.map((o) => {
              return (
                <Fragment key={o.label}>
                  <h4>{o.label}</h4>
                  {o.projects.map((project) => {
                    return (
                      <table>
                        <thead>
                          <tr>
                            <th>{project.label}</th>
                            {periods.map((p) => (
                              <th key={p}>{p}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {project.indicators.map((indicator) => {
                            const { id, label, unit, type, performances } =
                              indicator;
                            return (
                              <tr key={id}>
                                <td>
                                  {label}
                                  <br />
                                  <small>{IndicatorTypeLabels[type]}</small>
                                </td>
                                {periods.map((p) => {
                                  return (
                                    <td key={p}>
                                      {displayPerformance(
                                        getPerformanceAndPrevious(
                                          performances,
                                          p,
                                          periods,
                                        ),
                                        unit,
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    );
                  })}
                </Fragment>
              );
            })}
          </Fragment>
        );
      })}
    </Fragment>
  );
}
